import { useMemo } from 'react';

import { useGetRegions } from '@/hooks';

import type { RegionOption } from './types';

const useGetRegionOptions = (enabled = true) => {
  const { data, isLoading } = useGetRegions({ enabled });

  const options = useMemo<RegionOption[]>(() => {
    return data.map(region => ({
      label: region.name,
      value: region.id
    }));
  }, [data]);

  // Report loading only for the initial fetch (no data yet). Folding in
  // `fetchStatus === 'fetching'` would flash the region selector back to a
  // skeleton on every background refetch even though cached options exist.
  return {
    isLoading,
    options
  };
};

export default useGetRegionOptions;
